import LoadingGif from "components/v1/main/structure/LoadingGif";
import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
const ResourceCenter = lazy(() => import("./ResourceCenter"));

const utilitiesRoutes = 
	<>
		<Route path="/utilities/resource-center" element={
			<Suspense fallback={<LoadingGif loading center />}><ResourceCenter /></Suspense>
		} />
	</>;

export default utilitiesRoutes;